import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { Customers } from "./Customers";

export const customers = typeCheckAppModule({
    NAME,
    Container: Customers,
});
